module.exports = __webpack_public_path__ + "assets/images/mail-1pcYeCO.png";